import { api, httpClient } from './api';
import { grundHeader } from '../components/ui/loeschen-mit-grund-dialog';

export type TaskStatusFilter = 'open' | 'all';

export interface Task {
  id: number;
  title: string;
  description?: string | null;
  dueAt: string; // ISO datetime string
  isDone: boolean;
  assignedUserId: number;
  createdByUserId: number;
  personHistoryId?: number | null;
  createdAt: string;
  updatedAt: string;
  /** Gemeldete Abwesenheit einer Lehrkraft hinter der Aufgabe (T-0190). */
  abwesenheit?: {
    id: number;
    status: 'gemeldet' | 'abgesagt' | string;
    kursId: number | null;
    trialId: number | null;
    datum: string;
    beginn: string | null;
    ende: string | null;
    lehrerId: number;
    kursName: string | null;
    raumId: number | null;
  } | null;
}

export interface ListTasksParams {
  assignedUserId?: number;
  personHistoryId?: number;
  status?: TaskStatusFilter;
  dueAtLte?: string; // YYYY-MM-DD
  standortId?: number;
  /** Aufgaben ohne Bearbeiter (ans ganze Büro) mitliefern. */
  inklUnzugewiesen?: boolean;
}

export interface CreateTaskPayload {
  title?: string;
  description?: string;
  dueAt: string; // ISO datetime string
  assignedUserId: number;
  personHistoryId?: number;
  standortId?: number;
}

export interface UpdateTaskPayload {
  title?: string | null;
  description?: string | null;
  dueAt?: string;
  assignedUserId?: number;
  isDone?: boolean;
  personHistoryId?: number | null;
  standortId?: number | null;
}

export const tasksApi = {
  list: async (params: ListTasksParams = {}): Promise<Task[]> => {
    const query = new URLSearchParams();
    if (params.assignedUserId !== undefined) query.set('assignedUserId', String(params.assignedUserId));
    if (params.personHistoryId !== undefined) query.set('personHistoryId', String(params.personHistoryId));
    if (params.status) query.set('status', params.status);
    if (params.dueAtLte) query.set('dueAtLte', params.dueAtLte);
    if (params.standortId !== undefined) query.set('standort_id', String(params.standortId));
    if (params.inklUnzugewiesen) query.set('inklUnzugewiesen', 'true');
    const qs = query.toString();
    return api.get<Task[]>(`/api/tasks${qs ? `?${qs}` : ''}`);
  },

  create: async (payload: CreateTaskPayload): Promise<Task> => {
    return api.post<Task>('/api/tasks', payload);
  },

  update: async (id: number, payload: UpdateTaskPayload): Promise<Task> => {
    const res = await httpClient<Task>(`/api/tasks/${id}`, { method: 'PATCH', body: JSON.stringify(payload) });
    if (res.error) throw new Error(res.error);
    if (!res.data) throw new Error('Task konnte nicht aktualisiert werden');
    return res.data;
  },

  patch: async (id: number, payload: UpdateTaskPayload): Promise<Task> => {
    const res = await httpClient<Task>(`/api/tasks/${id}`, { method: 'PATCH', body: JSON.stringify(payload) });
    if (res.error) throw new Error(res.error);
    if (!res.data) throw new Error('Task konnte nicht aktualisiert werden');
    return res.data;
  },

  toggleDone: async (id: number, isDone: boolean): Promise<Task> => {
    const res = await httpClient<Task>(`/api/tasks/${id}/toggle-done`, { method: 'PATCH', body: JSON.stringify({ isDone }) });
    if (res.error) throw new Error(res.error);
    if (!res.data) throw new Error('Task konnte nicht umgeschaltet werden');
    return res.data;
  },

  remove: async (id: number, grund: string): Promise<void> => {
    await api.delete(`/api/tasks/${id}`, grundHeader(grund));
  },
};


